import React from 'react'
import { useNavigate } from 'react-router-dom'
import { NavBar, Icon } from 'antd-mobile'

import './index.css'

function NavBarPage(props) {
  const navigate = useNavigate()
  const {
    children,
    title = '标题',
    type = 'left',
    onLeftClick = () => {
      navigate(-1)
    },
  } = props

  return (
    <div>
      <NavBar
        className="nav-bar"
        mode="dark"
        onLeftClick={onLeftClick}
        leftContent={<Icon type={type} />}
      >
        {title}
      </NavBar>
      <div className="content">{children}</div>
    </div>
  )
}

export default NavBarPage
